import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./WelcomeModal.css";
import SlImage from "../../assets/img/sl.png";
import UkImage from "../../assets/img/uk.png";
import AdelmaImagePng from "../../assets/img/adelmaNBG.png";

const WelcomeModal = ({ onClose }) => {
  const { t, i18n } = useTranslation();
  const [activeLang, setActiveLang] = useState(i18n.language);
  const [isMobile, setIsMobile] = useState(false);

  // Detekcija mobilne naprave
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Preveri ob zagonu
    checkIfMobile();
    
    // Preveri ob spremembi velikosti okna
    window.addEventListener('resize', checkIfMobile);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
    setActiveLang(lng);
  };

  // Prilagoditev stylinga za modalno okno na mobilnih napravah
  useEffect(() => {
    if (isMobile) {
      // Prepreči scrollanje ozadja
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      // Povrni scrollanje ob zaprtju modalnega okna
      document.body.style.overflow = 'auto';
    };
  }, [isMobile]);

  return (
    <div className="welcome-modal-overlay">
      <div className="welcome-modal">
        <picture>
          <source srcSet={AdelmaImagePng} type="image/png" />
          <img src={AdelmaImagePng} alt="Adelma AI" className="avatar-modal" />
        </picture>
        <h2>Adelma AI</h2>
        <h5>{t("chooseLangMessage")}</h5>
        <div className="language-switcher-modal">
          <button
            className={`lang-button-modal ${activeLang === "en" ? "active" : ""}`}
            onClick={() => changeLanguage("en")}
            aria-label="Switch to English"
          >
            <img
              src={UkImage}
              alt="United Kingdom flag"
              className="flag-icon-modal"
            />{" "}
            {t("changeLangEn")}
          </button>
          <button
            className={`lang-button-modal ${activeLang === "sl" ? "active" : ""}`}
            onClick={() => changeLanguage("sl")}
            aria-label="Switch to Slovenian"
          >
            <img
              src={SlImage}
              alt="Slovenian flag"
              className="flag-icon-modal"
            />{" "}
            {t("changeLangSl")}
          </button>
        </div>
        <p>
        <b>{t("welcomeMessage")}</b>
        </p>
        <p>
        {t("disclaimer")}
        </p>
        <div className="welcome-modal-footer">
          <p>
            {t("cookieNotice")} <a href="/privacy">{t("learnMore")}</a>
          </p>
          <button
            className="welcome-modal-button"
            onClick={onClose}
            aria-label="Close welcome modal"
          >
            {t("iUnderstand")}
          </button>
          <div className="welcome-modal-checkbox">
            <label>
              <input type="checkbox" defaultChecked /> {t("dontShowAgain")}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
